import { VUtils } from "../worldbuilder/utils";
import { ModifierMapping } from "./enums";
import { TimeDistanceCalculator } from "./timedistancecalculator";
export class TimeDistance {
    static Init() {
        const form = document.getElementById("travelform");
        form.addEventListener("input", TimeDistance.HandleFormChange);
        TimeDistance.HandleFormChange();
    }
    static HandleFormChange() {
        const formData = new FormData(document.getElementById("travelform"));
        const isKm = formData.get("distancemeasurement") === "Kilometers";
        const isDeterminingDistance = formData.get("timedistancepicker") !== "Distance";
        const travelSettings = TimeDistance.GetTravelSettingsFromForm(formData);
        const kmPerDay = TimeDistance.GetKmPerDay(travelSettings);
        let parsedDistanceKM;
        let parsedDaysTravelled;
        if (isDeterminingDistance) {
            const daysTravelled = formData.get("timeinput");
            parsedDaysTravelled = Number.parseFloat(daysTravelled);
            parsedDistanceKM = TimeDistanceCalculator.ComputeDistanceFromTime(parsedDaysTravelled, kmPerDay);
        }
        else {
            const distance = formData.get("distanceinput");
            parsedDistanceKM = Number.parseFloat(distance);
            if (!isKm) {
                parsedDistanceKM = parsedDistanceKM * 1.609;
            }
            parsedDaysTravelled = TimeDistanceCalculator.ComputeTimeFromDistance(parsedDistanceKM, kmPerDay);
        }
        TimeDistance.synchronizedistancetime(parsedDistanceKM, isKm, parsedDaysTravelled, isDeterminingDistance);
    }
    static GetKmPerDay(travelSettings) {
        return ModifierMapping.GetMethodRange(travelSettings.Method).GetResult(false) * TimeDistanceCalculator.ComputeRangeModifier(travelSettings);
    }
    static GetTravelSettingsFromForm(formData) {
        const weather = formData.get("travelweather");
        const method = formData.get("travelmethod");
        const load = formData.get("travelcapacity");
        const pace = formData.get("travelspeed");
        const difficulty = formData.get("traveldifficulty");
        if (typeof (weather) !== "string") {
            throw new Error();
        }
        if (typeof (method) !== "string") {
            throw new Error();
        }
        if (typeof (load) !== "string") {
            throw new Error();
        }
        if (typeof (pace) !== "string") {
            throw new Error();
        }
        if (typeof (difficulty) !== "string") {
            throw new Error();
        }
        const parsedWeather = Number.parseInt(weather, 10);
        const parsedMethod = Number.parseInt(method, 10);
        const parsedLoad = Number.parseInt(load, 10);
        const parsedPace = Number.parseInt(pace, 10);
        const parsedTerrain = Number.parseInt(difficulty, 10);
        return {
            Load: parsedLoad,
            Method: parsedMethod,
            Pace: parsedPace,
            Terrain: parsedTerrain,
            Weather: parsedWeather,
        };
    }
    static synchronizedistancetime(distanceKm, isMetric, timeDays, isDeterminingDistance) {
        const distanceUnitSpan = document.getElementById("distance_unit");
        distanceUnitSpan.innerText = isMetric ? "km" : "miles";
        const timeInput = document.getElementById("timeinput");
        const distanceInput = document.getElementById("distanceinput");
        if (isDeterminingDistance) {
            timeInput.style.display = "";
            distanceInput.style.display = "none";
        }
        else {
            timeInput.style.display = "none";
            distanceInput.style.display = "";
        }
        const outputElement = document.getElementById("tdoutput");
        if (!isNaN(distanceKm) && !isNaN(timeDays) && distanceKm >= 0 && timeDays >= 0) {
            outputElement.style.visibility = "";
            const standardizedDistance = VUtils.prettyPrintRounded(isMetric ? distanceKm : distanceKm * 0.621371);
            const standardizedTime = VUtils.prettyPrintRounded(timeDays);
            outputElement.innerHTML = `My destination is <strong>${standardizedDistance} ${isMetric ? "km" : "miles"}</strong> away and it will take <strong>${standardizedTime} days</strong> to get there.`;
        }
        else {
            outputElement.style.visibility = "hidden";
        }
    }
}
TimeDistance.Init();
//# sourceMappingURL=timedistance.js.map